export default "skymp5-front/ad1f817dd17374e2bd7486b3a5ac47a8.svg";